export default __webpack_public_path__ + "static/media/sv11_en_head_a1.ed9f65b1.mp3";